import settings from '@settings'
import i18n from 'i18next'
import { configuration, useLanguageSelectionQry } from 'mmfintech-backend-api'
import { initializeLanguage, useSearchParams } from 'mmfintech-commons'
import { LanguageMenu } from 'mmfintech-portal-commons'
import { useEffect } from 'react'

export const MMLanguageMenu = () => {
  const params = useSearchParams()

  const { userLanguage, setUserLanguage } = useLanguageSelectionQry()

  const selectLanguage = (languageCode: string) => {
    localStorage.setItem('language', languageCode)
    setUserLanguage(languageCode)
    if (i18n.language !== languageCode) {
      initializeLanguage(languageCode)
    }
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: check query params and set selected language
  useEffect(() => {
    const langParam = params?.get('lang')
    if (langParam && settings.languages.includes(langParam)) {
      selectLanguage(langParam)
    }
  }, [params])

  // biome-ignore lint/correctness/useExhaustiveDependencies: set local session language if different
  useEffect(() => {
    const sessionLang = localStorage.getItem('language')
    if (sessionLang && sessionLang !== i18n.language) {
      selectLanguage(sessionLang)
    }
  }, [])

  // biome-ignore lint/correctness/useExhaustiveDependencies: check user language when loaded if different
  useEffect(() => {
    if (userLanguage && userLanguage !== i18n.language) {
      selectLanguage(userLanguage)
    }
  }, [userLanguage])

  return (
    <LanguageMenu
      currentLanguage={i18n.language}
      onChange={selectLanguage}
      supported={settings.languages}
      baseUrl={configuration.getBaseUrl()}
    />
  )
}
